import React from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AdminTable from '../Helpers/AdminTable'
import TableTitle from '../Helpers/TableTitle'
import { useState } from 'react'
import SureModal from 'src/components/Modals/SureModal'
import { stocksAction } from 'src/store/Slices/Administrator/StocksSlice'
// import AddEditStocksModal from './Modals/AddEditStocksModal'
// import MobileStocks from './Mobile/MobileStocks'
import { passagesAction } from 'src/store/Slices/Administrator/PassagesSlice'
import { formatIsoToDateNew, formatIsoToTime, formateDate } from 'src/components/helpers/formateDate'
import { element } from 'prop-types'
import Title from 'antd/es/skeleton/Title'
import { width } from '@mui/system'
import { findKey } from 'lodash'
import MobilePassages from './Mobile/MobilePassages'
import { openNotification } from 'src/components/helpers/notification'

const Passages = ({mnemo}) => {

    const dispatch = useDispatch()

    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const [stockInfo, setStockInfo] = useState()
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({ open: false, flag: '' })
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)

    // STORE
    const passagesList = useSelector(state => state.PassagesSlice.passagesList)
    const passagesLoading = useSelector(state => state.PassagesSlice.passagesLoading)
    const rows = passagesList?.data?.value?.rows.map((element) => {
        return (
          {
            ...element,
            date: element.date ? formatIsoToDateNew(element.date) + ' ' + formatIsoToTime(element.date) : '',

          }
        )
      })

    const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
        keys.forEach((key, index) => {
            if (values[index] && values[index][0] !== undefined && values[index][0] !== null) {
                if (key === 'userId') {
                    formattedItems['UserIdFrom'] = values[index][0];
                    formattedItems['UserIdTo'] = values[index][1];
                } else if (key === 'date') {
                    formattedItems['DateFrom'] = values[index][0];
                    formattedItems['DateTo'] = values[index][1];
                } else if (key === 'clubName') {
                    formattedItems['clubId'] = values[index][0]
                } else if (key === 'Status') {
                    formattedItems['status'] = values[index][0];
                } else {
                    formattedItems[key] = values[index][0];
                }
            }
        });
        return formattedItems;
    }
};

    const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',]

    const newDate = new Date()

    passagesList?.data?.value?.totalCount === 0 && openNotification({
        type: 'info',
        message: 'За выбранный период (по умолчанию сегодня) нет записей, попробуйте изменить фильтр "Дата"'
    })
    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(Object.keys(filters), Object.values(filters))
        dispatch(passagesAction({
            flag: 'get', value: {
                DateFrom: `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${months[newDate.getMonth()]} ${newDate.getFullYear()} 00:00:00`,
                DateTo: `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${months[newDate.getMonth()]} ${newDate.getFullYear()} 23:59:59`,
                Count: pagination.pageSize,
                Offset: pagination.pageSize * (pagination.current - 1),
                OrderBy: sorter?.column?.dataIndex,
                isDesc: sorter.order ? sorter.order === 'ascend' ? true : false : undefined,
                ...payload
            }
        }))
        setPage(pagination.current)
        setPageSize(pagination.pageSize)
    }

    

    useEffect(() => {
        dispatch(passagesAction({ flag: 'get', value:{
            DateFrom: `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${months[newDate.getMonth()]} ${newDate.getFullYear()} 00:00:00`,
            DateTo: `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${months[newDate.getMonth()]} ${newDate.getFullYear()} 23:59:59` }}))
    }, [])

    return (
        <>
            {/* <AddEditStocksModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                stockInfo={stockInfo}
            /> */}
            {/* <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            /> */}
            {window.innerWidth >= 768 ? <AdminTable
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                onChange={handleTableChange}
                loading={passagesLoading}
                onClickRowOne={(record) => { setStockInfo(record) }}
                columns={passagesList}
                rows={rows}
                total={passagesList?.data?.value?.totalCount}
            />
                : <>
                <MobilePassages
                     page={page}
                     setPage={setPage}
                     setPageSize={setPageSize}
                     servicesList={passagesList}
                     servicesListLoading={passagesLoading}
                 />
                </>
                 
            }
        </>
    )
}

export default Passages